import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'
import fibres from './fibres.svg'

export const TuileAiguillage = ({ title, CTA: { analytics, URL, label } }) => {
   document.documentElement.style.setProperty('--img-fibres-aiguillage', `url(${fibres})`)

   return (
      <a
         href={URL}
         class="tuile-aiguillage lien-composite"
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={analytics.pdbVi}
         data-pdb-ta={analytics.pdbTa}
         data-adv-canal={analytics.advCanal}
         data-adv-cappingdata={analytics.advCappingdata}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
      >
         <h3 class="h4 title m-0 p-0">
            <span dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
         </h3>
         <span href={URL} class="btn btn-primary btn-inverse">
            {label}
         </span>
      </a>
   )
}
